module.exports = __webpack_public_path__ + "static/fabric-select-single-48539c52db6ec2eea558034c0bafbf40.png";